import { HELPFUL_RATING_VALUE, UNHELPFUL_RATING_VALUE } from '../constants/ArticleFeedbackConstants';
function getCountGenericRating(submissionCountsByRating, countTotal, ratingKey) {
  if (countTotal === 0 || submissionCountsByRating.length === 0) {
    return 0;
  }
  const {
    key: firstRatingKey,
    count: firstRatingCount
  } = submissionCountsByRating[0];
  return Number(firstRatingKey) === ratingKey // crm search key is floating point string
  ? firstRatingCount : countTotal - firstRatingCount;
}
export function getCountHelpfulRating(submissionCountsByRating, countTotal) {
  return getCountGenericRating(submissionCountsByRating, countTotal, HELPFUL_RATING_VALUE);
}
export function getCountUnhelpfulRating(submissionCountsByRating, countTotal) {
  return getCountGenericRating(submissionCountsByRating, countTotal, UNHELPFUL_RATING_VALUE);
}